import { Component } from 'react';

// Components
import Navbar from './navbar/index';
import Home from './home/index';
import Service from './services/index';
import Client from './clients/index';
import ContactUs from './contactus/index';
import AboutUs from './aboutus/index';
import Footer from './footer/index';

export default class App extends Component {

    render() {
        return (
            <div className='Component'>
                <Navbar />
                <Home />
                <Service />
                <Client />
                <ContactUs />
                <AboutUs />
                <Footer />
            </div>
        );
    }
}